export const CmDashboardAnalyticsTypes = {
    community: 'Community',
    events: 'Events',
    sessions: 'Sessions',
    speakers: 'Speakers',
    gettingStarted: 'GettingStarted',
    helpCenter: 'HelpCenter',
};
